module.exports = __webpack_public_path__ + "static/media/chmurka_temp_zew.567081e4.svg";